import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import fleshblack from "../assets/images/arrow-icons/black.png";

export default function ScrollTopButton() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.5 }}
          onClick={scrollToTop}
          className="
            fixed bottom-6 right-6
            w-8 h-8 text-lg sm:w-10 sm:h-10 sm:text-xl
            md:w-12 md:h-12 md:text-2xl
            lg:w-14 lg:h-14 lg:text-3xl
            xl:w-16 xl:h-16 xl:text-4xl
            rounded-full border-2 border-white
            bg-white mix-blend-difference
            flex items-center justify-center
            font-bold cursor-pointer text-black
            transition-all duration-200
            z-[999999]
            animate-jump
          "
        >
          <img
            src={fleshblack}
            alt="Scroll to top"
            className="w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10"
          />
        </motion.button>
      )}
    </AnimatePresence>
  );
}
